<div *ngIf="isLoading" class="po-loading-state">
  <div class="po-loading-pulse"></div>
  <p>Loading payment details...</p>
</div>

<div *ngIf="!isLoading" class="po-container">

  <!-- Payee Information Card -->
  <form *ngIf="isRazorpay" [formGroup]="form" class="po-card">
    <div class="po-card-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.03 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
      </svg>
      Payee Information
    </div>
    <div class="po-card-body">
      <div class="po-form-grid">
        <div class="po-field">
          <label class="po-label">Payee Name <span class="po-required">*</span></label>
          <input
            class="po-input"
            [ngClass]="{ 'po-input-error': submitted && f['name'].errors }"
            pattern="^[a-zA-Z0-9_][a-zA-Z0-9_ ]*[a-zA-Z0-9_]$"
            formControlName="name"
            [(ngModel)]="paymentDetails.payeeName"
            placeholder="Enter Name"
            type="text"
          />
          <div *ngIf="submitted && f['name'].errors" class="po-error-msg">
            <span *ngIf="f['name'].errors['required']">Please enter name</span>
            <span *ngIf="f['name'].errors['pattern']">Please enter a valid name</span>
          </div>
        </div>
        <div class="po-field">
          <label class="po-label">Payee Email <span class="po-required">*</span></label>
          <input
            class="po-input"
            [ngClass]="{ 'po-input-error': submitted && f['email'].errors }"
            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
            formControlName="email"
            [(ngModel)]="paymentDetails.payeeEmail"
            placeholder="Enter Email"
            type="text"
          />
          <div *ngIf="submitted && f['email'].errors" class="po-error-msg">
            <span *ngIf="f['email'].errors['required']">Please enter email</span>
            <span *ngIf="f['email'].errors['pattern']">Please enter a valid email</span>
          </div>
        </div>
        <div class="po-field">
          <label class="po-label">Payee Contact <span class="po-required">*</span></label>
          <input
            class="po-input"
            [ngClass]="{ 'po-input-error': submitted && f['contact_number'].errors }"
            pattern="^(?!0+$)(\+\d{1,3}[- ]?)?(?!0+$)\d{10}$"
            formControlName="contact_number"
            [(ngModel)]="paymentDetails.payeeMobileNumber"
            placeholder="Enter Mobile Number"
            type="text"
            (keypress)="numberOnly($event)"
            minlength="10"
            maxlength="10"
          />
          <div *ngIf="submitted && f['contact_number'].errors" class="po-error-msg">
            <span *ngIf="f['contact_number'].errors['required']">Please enter contact number</span>
            <span *ngIf="f['contact_number'].errors['pattern']">Phone number must be 10 digits</span>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Payment Breakdown -->
  <div *ngIf="isWalletPrepaid || isWalletPostpaidWithStamps || isRazorpay">

    <!-- Stamp Details Card -->
    <div *ngIf="stampDetails.length != 0" class="po-card">
      <div class="po-card-header po-header-stamp">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3zm0 1h10v14H3V1z"/>
          <path d="M4.5 4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"/>
        </svg>
        Stamp Details
        <span class="po-badge po-badge-stamp">{{ stampDetails.length }} {{ stampDetails.length === 1 ? 'Stamp' : 'Stamps' }}</span>
      </div>
      <div class="po-table-wrap">
        <app-data-table
          [columns]="stampColumns"
          [data]="visibleStampDetails"
          [paginator]="false">
          <ng-template appTableCell="sr_no" let-row let-i="index">
            {{ i + 1 }}
          </ng-template>
          <ng-template appTableCell="stamp_duty" let-row>
            {{ usedCurrency }} {{ row.stamp_duty_amount || 0 }}
          </ng-template>
          <ng-template appTableCell="cess" let-row>
            {{ usedCurrency }} {{ inventoryPayment ? (row.stamp_duty_amount * (row.cessPer || 0)) : isStampPreProcurement ? 0 : (row.stamp_duty_amount * (row.cessPer || 0)) }}
          </ng-template>
          <ng-template appTableCell="convenience_fee" let-row>
            {{ usedCurrency }} {{ inventoryPayment ? stampPrice : isStampPreProcurement ? 0 : isWalletPostpaidWithStamps ? 0 : stampPrice }}
          </ng-template>
          <ng-template appTableCell="amount" let-row>
            {{ usedCurrency }}
            {{
              (inventoryPayment ? row.stamp_duty_amount : isStampPreProcurement ? 0 : row.stamp_duty_amount) +
              (inventoryPayment ? (stampPrice * (row.stamp_count || 0)) : isStampPreProcurement ? 0 : isWalletPostpaidWithStamps ? 0 : (stampPrice * (row.stamp_count || 0))) +
              (inventoryPayment ? (row.stamp_duty_amount * (row.cessPer || 0)) : isStampPreProcurement ? 0 : (row.stamp_duty_amount * (row.cessPer || 0)))
            }}
          </ng-template>

          <ng-template appTableFooter>
            <tr class="po-subtotal-row">
              <td colspan="7">Stamp Total Amount</td>
              <td>{{ usedCurrency }} {{ stampAmountTotal }}</td>
            </tr>
          </ng-template>
        </app-data-table>
      </div>
    </div>

    <!-- E-Sign Details Card -->
    <div *ngIf="signDetails.length != 0" class="po-card" style="margin-top: 20px;">
      <div class="po-card-header po-header-esign">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
        </svg>
        E-Sign Details
        <span class="po-badge po-badge-esign">{{ signDetails.length }} {{ signDetails.length === 1 ? 'Signer' : 'Signers' }}</span>
      </div>
      <div class="po-table-wrap">
        <app-data-table
          [columns]="esignColumns"
          [data]="esignRows"
          [paginator]="false">
          <ng-template appTableCell="method" let-row>
            <span class="po-method-badge" [ngClass]="row.methodClass">{{ row.methodLabel }}</span>
          </ng-template>
          <ng-template appTableCell="price" let-row>
            {{ usedCurrency }} {{ row.price }}
          </ng-template>
          <ng-template appTableCell="amount" let-row>
            {{ usedCurrency }} {{ row.amount }}
          </ng-template>

          <ng-template appTableFooter>
            <tr class="po-subtotal-row">
              <td colspan="4">E-Sign Total Amount</td>
              <td>{{ usedCurrency }} {{ signAmountTotal }}</td>
            </tr>
          </ng-template>
        </app-data-table>
      </div>
    </div>

    <!-- Order Summary -->
    <div class="po-summary-card" style="margin-top: 20px;">
      <div class="po-summary-title">Order Summary</div>
      <table class="po-summary-table">
        <tbody>
          <tr class="po-summary-row">
            <td class="po-summary-label">Order Total</td>
            <td class="po-summary-value">{{ usedCurrency }} {{ signAmountTotal + stampAmountTotal }}</td>
          </tr>
          <tr class="po-summary-row">
            <td class="po-summary-label">GST</td>
            <td class="po-summary-value">{{ usedCurrency }} {{ (gstOnEsignFee + gstOnStampFee).toFixed(2) }}</td>
          </tr>
          <tr *ngIf="isRazorpay" class="po-summary-row">
            <td class="po-summary-label">Handling Charges</td>
            <td class="po-summary-value">{{ usedCurrency }} {{ razorpayHandlingCharge }}</td>
          </tr>
          <tr class="po-summary-row po-payable-row">
            <td class="po-payable-label">Payable Amount</td>
            <td class="po-payable-amount">{{ usedCurrency }} {{ paymentAmount }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <!-- Postpaid Info Message -->
  <div
    *ngIf="isWalletPostpaidWithoutStamps || (isWalletPostpaidWithStamps && isStampPreProcurement)"
    class="po-info-banner"
  >
    <div class="po-info-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
      </svg>
    </div>
    <p>Wallet payment is of <strong>POSTPAID</strong> type — no payment required now. Please proceed with Place Order.</p>
  </div>

  <!-- Insufficient Wallet Balance Warning -->
  <div *ngIf="!canWalletPayment && isWallet" class="po-warning-banner">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
    </svg>
    Cannot place order due to insufficient wallet balance.
  </div>

   <div *ngIf="paymentAmount === 0" class="po-payment-note">
      <small><b>*No wallet deduction required. Your payment is pre-processed. Click 'Place Order' to continue.</b></small>
   </div>
    <div *ngIf="isWallet" class="po-payment-note">
      <small>*The amount will be deducted from your wallet. Click 'Place Order' to proceed.</small>
    </div>

  <!-- Action Buttons -->
  <div class="po-actions">
    <p-button
      *ngIf="isRazorpay"
      [disabled]="!form.valid"
      label="Send Payment Link"
      (click)="payBill()"
      styleClass="p-button-sm-outline"
    ></p-button>
    <p-button
      [disabled]="!form.valid || (isWallet && !canWalletPayment)"
      [label]="isWallet || isWalletPostpaidWithoutStamps || (isWalletPostpaidWithStamps && isStampPreProcurement) ? 'Place Order': 'Pay Now'"
      (click)="payBillNow()"
      styleClass="p-button-sm-outline"
      class="pay-now"
    ></p-button>
  </div>

  <div class="toast_display_layer">
    <p-toast></p-toast>
  </div>

  <ng-template #reviewOrder let-modal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        (click)="closeModel()"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-content">
      <div class="modal-body">
        <app-review-order-details
          [reviewOrderData]="reviewOrderData"
          [paymentAmount]="paymentAmount"
          [isPaymentActive]="isPaymentActive"
          (addingReviewer)="addingReviewer($event)"
        ></app-review-order-details>
      </div>
    </div>
  </ng-template>

  <div>
    <ng-template #paymentModal let-modal>
      <div class="modal-content" id="payment-modal">
        <div class="modal-body">
          <div class="payment-container">
            <div class="payment-message">
              <div class="spinner"></div>
              <h1>Payment is Processing</h1>
              <p>
                Please do not refresh your page or click the "Back" or "Close"
                button<br />
                until the process is complete.
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div>
    <ng-template #confirmOrderModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Confirmation</h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeConfirmModal()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-content">
        <div class="modal-body">
          <i class="pi pi-exclamation-circle" style="font-size: 2rem; color: #f59e0b"></i>
          <p>Do you want to get your request to be reviewed by Checker?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onRejectConfirm()">
            <i class="pi pi"></i> Yes
          </button>
          <button type="button" class="btn btn-primary" (click)="onAcceptConfirm()">
            <i class="pi pi"></i> No, Proceed to Place Order
          </button>
        </div>
      </div>
    </ng-template>
  </div>

</div>
